import { cardinalAngles } from "../rebar/preview/preview-constants";

//CONSTANTS for the height lines on the shapes
const horizontalLine = 30;
const verticalLine = 25;

//Input Boxes
const inputBoxLeftGap = 85;
const inputBoxRightGap = 35;

//Text Labels
const labelLeftGap = 68;
const labelRightGap = 53;
const labelTopGap = 25;

const leftPadding = 4;
const rightPadding = 6;
const rightPaddingSpecial = 16;

const heightLabelLeftPaddingScreenshot = -20;
const heightLabelRightPaddingScreenshot = 10;

export const calculateHeight = (length, angle) => {
  angle = angle * (Math.PI / 180);
  const height = length * Math.sin(angle);
  return Math.abs(height.toFixed(0));
};

export const lengthOnChangingHeight = (height, angle) => {
  angle = angle * (Math.PI / 180);
  const newLength = height / Math.sin(angle);
  return Math.abs(newLength.toFixed(0));
};

//Firstly there could be a line with outter true/false
//In false there are 4 types of lines (I guess each in every axis) and in true there are true

//Conditions are added for each line which tells me which points of the line is shorter/larger on the canvas ({x1,x2},{y1,y2})

// (1) By using that if I have to go to the left I am using the smallest point and I am subtracting a fixed number(30) which gives
//me second point(first line is drawn) and for the second line I know the first point which is the other end of the line and from
//there I am going to the point which I got earlier.

// (2) Similarly I f I have to go to the right I am adding that fixed point to the largest point and by using that I am
// getting second line similar to the point (1)

// (3) For the middle line in case of left side I am using the smallest point and for the right side i am using the largest side and
// subtracting a fixed number from it and getting the ({x1,y1},{x2,y2})

// (4) Other points are straight forward.

// (5) Overlapping Fixed by taking the difference of the vertical line's x-point  and text label's
// x-point. for each condition there is a diff point where overlapping occurs and paddings are also defined

const middlePoint = (point1, point2) => {
  return (point1 + point2) / 2;
};

const addValues = (value, padding, diff) => {
  return value + padding + diff;
};

const adjustOverlappingLines = (
  hzLine,
  vtLine,
  boxGap,
  labelGap,
  padding,
  diff
) => {
  const newHzLine = addValues(hzLine, padding, diff);
  const newVtLine = addValues(vtLine, padding, diff);
  const newBoxGap = addValues(boxGap, padding, diff);
  const newLabelGap = addValues(labelGap, padding, diff);
  return {
    hzLine: newHzLine,
    vtLine: newVtLine,
    boxGap: newBoxGap,
    labelGap: newLabelGap,
  };
};

//points factor is the value to move the height lines to the exact tip of the shape lines
const line1 = (linePoints, lineFactor) => {
  return {
    x1: linePoints.x,
    y1: linePoints.y,
    x2: linePoints.x - lineFactor,
    y2: linePoints.y,
  };
};

const line2 = (linePoints1, linePoints2, lineFactor) => {
  return {
    x1: linePoints1.x,
    y1: linePoints1.y,
    x2: linePoints2.x - lineFactor,
    y2: linePoints1.y,
  };
};

const inpBoxAndArrows = (xPoint, yPoint) => {
  return {
    x: xPoint,
    y: yPoint,
  };
};

export const shapeLinesForHeight = (
  side,
  rebar_side,
  currentPoint,
  previousPoint,
  index,
  inputPoints,
  sideHeight = 0,
) => {
  const outterInput =
    side.outer ||
    (index >= 1 &&
      !rebar_side[index - 1].change_previous_point &&
      rebar_side[index - 1].outer);

  let firstLine,
    secondLine,
    midLine,
    inputBox,
    previewLabel,
    label = {};
  let topArrow,
    bottomArrow = {};
  if (!outterInput) {
    //x2 < x1
    //y2 > y1
    // line towards bottom left
    if (currentPoint.x < previousPoint.x && currentPoint.y > previousPoint.y) {
      let lineFactors = {};

      let diff = Math.abs(
        Number(currentPoint.x - verticalLine) -
          Number(inputPoints[index].text.x)
      );

      if (diff < 15) {
        lineFactors = adjustOverlappingLines(
          horizontalLine,
          verticalLine,
          inputBoxLeftGap,
          labelLeftGap,
          leftPadding,
          diff
        );
      } else {
        lineFactors = {
          hzLine: horizontalLine,
          vtLine: verticalLine,
          boxGap: inputBoxLeftGap,
          labelGap: labelLeftGap,
        };
      }

      firstLine = line1(currentPoint, lineFactors.hzLine);
      secondLine = line2(
        previousPoint,
        currentPoint,
        lineFactors.hzLine,
      );
      midLine = {
        x1: currentPoint.x - lineFactors.vtLine,
        y1: currentPoint.y,
        x2: currentPoint.x - lineFactors.vtLine,
        y2: previousPoint.y,
      };
      const len = middlePoint(currentPoint.y, previousPoint.y);
      inputBox = inpBoxAndArrows(currentPoint.x - lineFactors.boxGap, len);
      label = inpBoxAndArrows(
        currentPoint.x - lineFactors.labelGap,
        len - labelTopGap
      );
      previewLabel = {x: label.x + heightLabelRightPaddingScreenshot, y: inputBox.y + 3}
      topArrow = inpBoxAndArrows(
        currentPoint.x - lineFactors.vtLine,
        previousPoint.y
      );
      bottomArrow = inpBoxAndArrows(
        currentPoint.x - lineFactors.vtLine,
        currentPoint.y
      );
    }
    //x2 > x1
    //y2 > y1
    // line towards bottom right
    else if (
      currentPoint.x > previousPoint.x &&
      currentPoint.y > previousPoint.y
    ) {
      let lineFactors = {};

      let diff = Math.abs(
        Number(previousPoint.x - verticalLine) -
          Number(inputPoints[index].text.x) +
          20
      );
      if (diff < 24) {
        lineFactors = adjustOverlappingLines(
          horizontalLine,
          verticalLine,
          inputBoxLeftGap,
          labelLeftGap,
          leftPadding,
          diff
        );
      } else {
        lineFactors = {
          hzLine: horizontalLine,
          vtLine: verticalLine,
          boxGap: inputBoxLeftGap,
          labelGap: labelLeftGap,
        };
      }

      firstLine = line1(previousPoint, lineFactors.hzLine);
      secondLine = line2(currentPoint, previousPoint, lineFactors.hzLine);

      midLine = {
        x1: previousPoint.x - lineFactors.vtLine,
        y1: currentPoint.y,
        x2: previousPoint.x - lineFactors.vtLine,
        y2: previousPoint.y,
      };
      const len = middlePoint(currentPoint.y, previousPoint.y);
      inputBox = inpBoxAndArrows(previousPoint.x - lineFactors.boxGap, len);
      label = inpBoxAndArrows(
        previousPoint.x - lineFactors.labelGap,
        len - labelTopGap
      );
      previewLabel = {x: label.x + heightLabelRightPaddingScreenshot, y: inputBox.y + 3}
      topArrow = inpBoxAndArrows(
        previousPoint.x - lineFactors.vtLine,
        previousPoint.y
      );
      bottomArrow = inpBoxAndArrows(
        previousPoint.x - lineFactors.vtLine,
        currentPoint.y
      );
    }
    //x1 > x2
    //y1 > y2
    // line towards top left
    else if (
      previousPoint.x > currentPoint.x &&
      previousPoint.y > currentPoint.y
    ) {
      let lineFactors = {};

      let diff = Math.abs(
        Number(inputPoints[index].text.x) -
          Number(previousPoint.x + verticalLine)
      );
      if (diff < 15) {
        lineFactors = adjustOverlappingLines(
          horizontalLine,
          verticalLine,
          inputBoxRightGap,
          labelRightGap,
          rightPadding,
          diff
        );
      } else {
        lineFactors = {
          hzLine: horizontalLine,
          vtLine: verticalLine,
          boxGap: inputBoxRightGap,
          labelGap: labelRightGap,
        };
      }

      //passing in -ve coz -- is +ve
      firstLine = line1(previousPoint, -lineFactors.hzLine);
      secondLine = line2(currentPoint, previousPoint, -lineFactors.hzLine);
      midLine = {
        x1: previousPoint.x + lineFactors.vtLine,
        y1: currentPoint.y,
        x2: previousPoint.x + lineFactors.vtLine,
        y2: previousPoint.y,
      };
      const len = middlePoint(currentPoint.y, previousPoint.y);
      inputBox = inpBoxAndArrows(previousPoint.x + lineFactors.boxGap, len);
      label = inpBoxAndArrows(
        previousPoint.x + lineFactors.labelGap,
        len - labelTopGap
      );
      previewLabel = {x: label.x+ heightLabelLeftPaddingScreenshot, y: inputBox.y + 3};
      topArrow = inpBoxAndArrows(
        previousPoint.x + lineFactors.vtLine,
        currentPoint.y
      );
      bottomArrow = inpBoxAndArrows(
        previousPoint.x + lineFactors.vtLine,
        previousPoint.y
      );
    }
    // x1 < x2
    // y1 > y2
    // line towards top right
    else if (
      currentPoint.x > previousPoint.x &&
      previousPoint.y > currentPoint.y
    ) {
      let newHorizontalLine = horizontalLine;
      let newVerticalLine = verticalLine;
      let newInputBoxRightGap = inputBoxRightGap;
      let newLabelRightGap = labelRightGap;

      let diff = Math.abs(
        Number(inputPoints[index].text.x) -
          Number(currentPoint.x + verticalLine)
      );
      if (diff < 24) {
        newHorizontalLine =
          diff < 5
            ? newHorizontalLine + rightPaddingSpecial + diff
            : diff > 14
            ? newHorizontalLine + rightPadding + diff / 2
            : newHorizontalLine + rightPadding + diff;
        newVerticalLine =
          diff < 5
            ? newVerticalLine + rightPaddingSpecial + diff
            : diff > 14
            ? newVerticalLine + rightPadding + diff / 2
            : newVerticalLine + rightPadding + diff;
        newInputBoxRightGap =
          diff < 5
            ? newInputBoxRightGap + rightPaddingSpecial + diff
            : diff > 14
            ? newInputBoxRightGap + rightPadding + diff / 2
            : newInputBoxRightGap + rightPadding + diff;
        newLabelRightGap =
          diff < 5
            ? newLabelRightGap + rightPaddingSpecial + diff
            : diff > 14
            ? newLabelRightGap + rightPadding + diff / 2
            : newLabelRightGap + rightPadding + diff;
      }

      firstLine = line1(currentPoint, -newHorizontalLine);
      secondLine = line2(previousPoint, currentPoint, -newHorizontalLine);
      midLine = {
        x1: currentPoint.x + newVerticalLine,
        y1: currentPoint.y,
        x2: currentPoint.x + newVerticalLine,
        y2: previousPoint.y,
      };
      const len = middlePoint(currentPoint.y, previousPoint.y);
      inputBox = inpBoxAndArrows(currentPoint.x + newInputBoxRightGap, len);
      label = inpBoxAndArrows(
        currentPoint.x + newLabelRightGap,
        len - labelTopGap
      );
      previewLabel = {x: label.x+ heightLabelLeftPaddingScreenshot, y: inputBox.y + 3}
      topArrow = inpBoxAndArrows(
        currentPoint.x + newVerticalLine,
        currentPoint.y
      );
      bottomArrow = inpBoxAndArrows(
        currentPoint.x + newVerticalLine,
        previousPoint.y
      );
    }
  }
  //Outter
  else {
    //x2 > x1
    //y2 > y1
    // line towards bottom right
    if (currentPoint.x > previousPoint.x && currentPoint.y > previousPoint.y) {
      let lineFactors = {};

      let diff =
        Number(currentPoint.x + verticalLine) -
        Number(inputPoints[index].text.x);
      if (diff < 3) {
        diff = Math.abs(diff);
        lineFactors = adjustOverlappingLines(
          horizontalLine,
          verticalLine,
          inputBoxRightGap,
          labelRightGap,
          rightPadding,
          diff
        );
      } else {
        lineFactors = {
          hzLine: horizontalLine,
          vtLine: verticalLine,
          boxGap: inputBoxRightGap,
          labelGap: labelRightGap,
        };
      }

      firstLine = line1(currentPoint, -lineFactors.hzLine);
      secondLine = line2(previousPoint, currentPoint, -lineFactors.hzLine);
      midLine = {
        x1: currentPoint.x + lineFactors.vtLine,
        y1: currentPoint.y,
        x2: currentPoint.x + lineFactors.vtLine,
        y2: previousPoint.y,
      };
      const len = middlePoint(currentPoint.y, previousPoint.y);
      inputBox = inpBoxAndArrows(currentPoint.x + lineFactors.boxGap, len);
      label = inpBoxAndArrows(
        currentPoint.x + lineFactors.labelGap,
        len - labelTopGap
      );
      previewLabel = {x: label.x+ heightLabelLeftPaddingScreenshot, y: inputBox.y + 3}
      topArrow = inpBoxAndArrows(
        currentPoint.x + lineFactors.vtLine,
        previousPoint.y
      );
      bottomArrow = inpBoxAndArrows(
        currentPoint.x + lineFactors.vtLine,
        currentPoint.y
      );
    }
    //x2 > x1
    //y2 < y1
    // line towards top right
    else if (
      currentPoint.x > previousPoint.x &&
      previousPoint.y > currentPoint.y
    ) {
      let lineFactors = {};

      let diff =
        Number(inputPoints[index].text.x) -
        Number(previousPoint.x - verticalLine);
      if (diff < 1) {
        diff = Math.abs(diff);
        lineFactors = adjustOverlappingLines(
          horizontalLine,
          verticalLine,
          inputBoxLeftGap,
          labelLeftGap,
          leftPadding,
          diff
        );
      } else {
        lineFactors = {
          hzLine: horizontalLine,
          vtLine: verticalLine,
          boxGap: inputBoxLeftGap,
          labelGap: labelLeftGap,
        };
      }

      firstLine = line1(previousPoint, lineFactors.hzLine);
      secondLine = line2(currentPoint, previousPoint, lineFactors.hzLine);
      midLine = {
        x1: previousPoint.x - lineFactors.vtLine,
        y1: currentPoint.y,
        x2: previousPoint.x - lineFactors.vtLine,
        y2: previousPoint.y,
      };
      const len = middlePoint(currentPoint.y, previousPoint.y);
      inputBox = inpBoxAndArrows(previousPoint.x - lineFactors.boxGap, len);
      label = inpBoxAndArrows(
        previousPoint.x - lineFactors.labelGap,
        len - labelTopGap
      );
      previewLabel = {x: label.x + heightLabelRightPaddingScreenshot, y: inputBox.y + 3}
      topArrow = inpBoxAndArrows(
        previousPoint.x - lineFactors.vtLine,
        currentPoint.y
      );
      bottomArrow = inpBoxAndArrows(
        previousPoint.x - lineFactors.vtLine,
        previousPoint.y
      );
    }
        // towards top left
        else if(previousPoint.x > currentPoint.x &&
          previousPoint.y > currentPoint.y){
            let lineFactors = {};
            let diff = Math.abs(
              Number(inputPoints[index].text.x) -
                Number(previousPoint.x + verticalLine)
            );
            if (diff < 15) {
              lineFactors = adjustOverlappingLines(
                horizontalLine,
                verticalLine,
                inputBoxRightGap,
                labelRightGap,
                rightPadding,
                diff
              );
            } else {
              lineFactors = {
                hzLine: horizontalLine,
                vtLine: verticalLine,
                boxGap: inputBoxRightGap,
                labelGap: labelRightGap,
              };
            }
      
            //passing in -ve coz -- is +ve
            firstLine = line1(previousPoint, -lineFactors.hzLine);
            secondLine = line2(currentPoint, previousPoint, -lineFactors.hzLine);
            midLine = {
              x1: previousPoint.x + lineFactors.vtLine,
              y1: currentPoint.y,
              x2: previousPoint.x + lineFactors.vtLine,
              y2: previousPoint.y,
            };
            const len = middlePoint(currentPoint.y, previousPoint.y);
            inputBox = inpBoxAndArrows(previousPoint.x + lineFactors.boxGap, len);
            label = inpBoxAndArrows(
              previousPoint.x + lineFactors.labelGap,
              len - labelTopGap
            );
            topArrow = inpBoxAndArrows(
              previousPoint.x + lineFactors.vtLine,
              currentPoint.y
            );
            bottomArrow = inpBoxAndArrows(
              previousPoint.x + lineFactors.vtLine,
              previousPoint.y
            );
        }
        // towards bottom left
        else if (previousPoint.x > currentPoint.x &&
          currentPoint.y > previousPoint.y){
            let lineFactors = {};
    
            let diff = Math.abs(
              Number(currentPoint.x - verticalLine) -
                Number(inputPoints[index].text.x)
            );
      
            if (diff < 15) {
              lineFactors = adjustOverlappingLines(
                horizontalLine,
                verticalLine,
                inputBoxLeftGap,
                labelLeftGap,
                leftPadding,
                diff
              );
            } else {
              lineFactors = {
                hzLine: horizontalLine,
                vtLine: verticalLine,
                boxGap: inputBoxLeftGap,
                labelGap: labelLeftGap,
              };
            }
      
            firstLine = line1(currentPoint, lineFactors.hzLine);
            secondLine = line2(previousPoint, currentPoint, lineFactors.hzLine);
            midLine = {
              x1: currentPoint.x - lineFactors.vtLine,
              y1: currentPoint.y,
              x2: currentPoint.x - lineFactors.vtLine,
              y2: previousPoint.y,
            };
            const len = middlePoint(currentPoint.y, previousPoint.y);
            inputBox = inpBoxAndArrows(currentPoint.x - lineFactors.boxGap, len);
            label = inpBoxAndArrows(
              currentPoint.x - lineFactors.labelGap,
              len - labelTopGap
            );
            topArrow = inpBoxAndArrows(
              currentPoint.x - lineFactors.vtLine,
              previousPoint.y
            );
            bottomArrow = inpBoxAndArrows(
              currentPoint.x - lineFactors.vtLine,
              currentPoint.y
            );  
        }    
  }
  return {
    firstLine: firstLine,
    secondLine: secondLine,
    midLine: midLine,
    inputBox: inputBox,
    label: label,
    topArrow: topArrow,
    bottomArrow: bottomArrow,
    previewLabel: previewLabel,
  };
};


// Constants For FreeForm 
const FreeHorizontalLine = 30;
const FreeVerticalLine = 25;
const FreeInputBoxLeftGap = 25;
const FreeInputBoxRightGap = 3;
const FreeLabelLeftGap = 23;
const FreeLabelRightGap = 8;
const FreeLabelTopGap = 3;

const FreeLeftPadding = 4;
const FreeRightPadding = 6;
const FreeRightPaddingSpecial = 16;

export const HeightLinesForFreeForm = (
  side,
  rebar_side,
  currentPoint,
  previousPoint,
  index,
  inputPoints
) => {

  let firstLine,
    secondLine,
    midLine,
    inputBox,
    label,
    topArrow,
    bottomArrow = {};
      // x2 < x1
      // y2 > y1
      if (currentPoint.x < previousPoint.x && currentPoint.y > previousPoint.y) {
        let newHorizontalLine = FreeHorizontalLine;
        let newVerticalLine = FreeVerticalLine;
        let newInputBoxLeftGap = FreeInputBoxLeftGap;
        let newLabelLeftGap = FreeLabelLeftGap;
  
        let diff = Math.abs(
          Number(currentPoint.x - FreeVerticalLine) -
            Number(inputPoints[index].text.x)
        );
  
        if (diff < 15) {
          newHorizontalLine = newHorizontalLine + FreeLeftPadding + diff;
          newVerticalLine = newVerticalLine + FreeLeftPadding + diff;
          newInputBoxLeftGap = newInputBoxLeftGap + FreeLeftPadding + diff;
          newLabelLeftGap = newLabelLeftGap + FreeLeftPadding + diff;
        }
  
        firstLine = {
          x1: previousPoint.x,
          y1: previousPoint.y,
          x2: previousPoint.x + newHorizontalLine,
          y2: previousPoint.y,
        };
        secondLine = {
          x1: currentPoint.x,
          y1: currentPoint.y,
          x2: previousPoint.x + newHorizontalLine,
          y2: currentPoint.y,
        };
        midLine = {
          x1: previousPoint.x + newVerticalLine,
          y1: previousPoint.y,
          x2: previousPoint.x + newVerticalLine,
          y2: currentPoint.y,
        };
        const len = (currentPoint.y + previousPoint.y) / 2;
        inputBox = {
          x: previousPoint.x + newInputBoxLeftGap + FreeInputBoxRightGap,
          y: len,
        };
        label = {
          x: previousPoint.x + newLabelLeftGap + FreeLabelRightGap,
          y: len - FreeLabelTopGap,
        };
        topArrow = {
          x: previousPoint.x + newVerticalLine,
          y: previousPoint.y,
        };
        bottomArrow = {
          x: previousPoint.x + newVerticalLine,
          y: currentPoint.y,
        };
      }
      //x2 > x1
      //y2 > y1
      else if (
        currentPoint.y > previousPoint.y
      ) {
        let newHorizontalLine = FreeHorizontalLine;
        let newVerticalLine = FreeVerticalLine;
        let newInputBoxLeftGap = FreeInputBoxLeftGap;
        let newLabelLeftGap = FreeLabelLeftGap;
  
        let diff = Math.abs(
          Number(previousPoint.x - FreeVerticalLine) -
            Number(inputPoints[index].text.x) +
            20
        );
        if (diff < 24) {
          newHorizontalLine = newHorizontalLine + FreeLeftPadding + diff;
          newVerticalLine = newVerticalLine + FreeLeftPadding + diff;
          newInputBoxLeftGap = newInputBoxLeftGap + FreeLeftPadding + diff;
          newLabelLeftGap = newLabelLeftGap + FreeLeftPadding + diff;
        }
  
        firstLine = {
          x1: currentPoint.x,
          y1: currentPoint.y,
          x2: currentPoint.x + newHorizontalLine,
          y2: currentPoint.y,
        };
        secondLine = {
          x1: previousPoint.x,
          y1: previousPoint.y,
          x2: currentPoint.x + newHorizontalLine,
          y2: previousPoint.y,
        };
        midLine = {
          x1: currentPoint.x + newVerticalLine,
          y1: currentPoint.y,
          x2: currentPoint.x + newVerticalLine,
          y2: previousPoint.y,
        };
        const len = (currentPoint.y + previousPoint.y) / 2;
        inputBox = {
          x: currentPoint.x + newInputBoxLeftGap + FreeInputBoxRightGap,
          y: len,
        };
        label = {
          x: currentPoint.x + newLabelLeftGap + FreeLabelRightGap,
          y: len - FreeLabelTopGap,
        };
        topArrow = {
          x: currentPoint.x + newVerticalLine,
          y: previousPoint.y,
        };
        bottomArrow = {
          x: currentPoint.x + newVerticalLine,
          y: currentPoint.y,
        };
      }
      //x1 > x2
      //y1 > y2
      else if (
        previousPoint.x > currentPoint.x &&
        previousPoint.y > currentPoint.y
      ) {
        let newHorizontalLine = FreeHorizontalLine;
        let newVerticalLine = FreeVerticalLine;
        let newInputBoxRightGap = FreeInputBoxRightGap;
        let newLabelRightGap = FreeLabelRightGap;
  
        let diff = Math.abs(
          Number(inputPoints[index].text.x) -
            Number(previousPoint.x + FreeVerticalLine)
        );
        if (diff < 15) {
          newHorizontalLine = newHorizontalLine + FreeRightPadding + diff;
          newVerticalLine = newVerticalLine + FreeRightPadding + diff;
          newInputBoxRightGap = newInputBoxRightGap + FreeRightPadding + diff;
          newLabelRightGap = newLabelRightGap + FreeRightPadding + diff;
        }
  
        firstLine = {
          x1: previousPoint.x,
          y1: previousPoint.y,
          x2: previousPoint.x + newHorizontalLine,
          y2: previousPoint.y,
        };
        secondLine = {
          x1: currentPoint.x,
          y1: currentPoint.y,
          x2: previousPoint.x + newHorizontalLine,
          y2: currentPoint.y,
        };
        midLine = {
          x1: previousPoint.x + newVerticalLine,
          y1: currentPoint.y,
          x2: previousPoint.x + newVerticalLine,
          y2: previousPoint.y,
        };
        const len = (currentPoint.y + previousPoint.y) / 2;
        inputBox = {
          x: previousPoint.x + newInputBoxRightGap + FreeInputBoxLeftGap,
          y: len,
        };
        label = {
          x: previousPoint.x + newLabelRightGap + FreeLabelLeftGap,
          y: len - FreeLabelTopGap,
        };
        topArrow = {
          x: previousPoint.x + newVerticalLine,
          y: currentPoint.y,
        };
        bottomArrow = {
          x: previousPoint.x + newVerticalLine,
          y: previousPoint.y,
        };
      }
      // x1 < x2
      // y1 > y2
      else if (
        previousPoint.y > currentPoint.y
      ) {
        let newHorizontalLine = FreeHorizontalLine;
        let newVerticalLine = FreeVerticalLine;
        let newInputBoxRightGap = FreeInputBoxRightGap;
        let newLabelRightGap = FreeLabelRightGap;
  
        let diff = Math.abs(
          Number(inputPoints[index].text.x) -
            Number(currentPoint.x + FreeVerticalLine)
        );
        if (diff < 24) {
          newHorizontalLine =
            diff < 5
              ? newHorizontalLine + FreeRightPaddingSpecial + diff
              : diff > 14
              ? newHorizontalLine + FreeRightPadding + diff / 2
              : newHorizontalLine + FreeRightPadding + diff;
          newVerticalLine =
            diff < 5
              ? newVerticalLine + FreeRightPaddingSpecial + diff
              : diff > 14
              ? newVerticalLine + FreeRightPadding + diff / 2
              : newVerticalLine + FreeRightPadding + diff;
          newInputBoxRightGap =
            diff < 5
              ? newInputBoxRightGap + FreeRightPaddingSpecial + diff
              : diff > 14
              ? newInputBoxRightGap + FreeRightPadding + diff / 2
              : newInputBoxRightGap + FreeRightPadding + diff;
          newLabelRightGap =
            diff < 5
              ? newLabelRightGap + FreeRightPaddingSpecial + diff
              : diff > 14
              ? newLabelRightGap + FreeRightPadding + diff / 2
              : newLabelRightGap + FreeRightPadding + diff;
        }
  
        firstLine = {
          x1: currentPoint.x,
          y1: currentPoint.y,
          x2: currentPoint.x + newHorizontalLine,
          y2: currentPoint.y,
        };
        secondLine = {
          x1: previousPoint.x,
          y1: previousPoint.y,
          x2: currentPoint.x + newHorizontalLine,
          y2: previousPoint.y,
        };
        midLine = {
          x1: currentPoint.x + newVerticalLine,
          y1: currentPoint.y,
          x2: currentPoint.x + newVerticalLine,
          y2: previousPoint.y,
        };
        const len = (currentPoint.y + previousPoint.y) / 2;
        inputBox = {
          x: currentPoint.x + newInputBoxRightGap + FreeInputBoxLeftGap,
          y: len,
        };
        label = {
          x: currentPoint.x + newLabelRightGap + FreeLabelLeftGap,
          y: len - FreeLabelTopGap,
        };
        topArrow = {
          x: currentPoint.x + newVerticalLine,
          y: currentPoint.y,
        };
        bottomArrow = {
          x: currentPoint.x + newVerticalLine,
          y: previousPoint.y,
        };
    }
    return {
    firstLine: firstLine,
    secondLine: secondLine,
    midLine: midLine,
    inputBox: inputBox,
    label: label,
    topArrow: topArrow,
    bottomArrow: bottomArrow,
  };
};

const hasHeight = (lineAngle) => {
  return !cardinalAngles.includes(lineAngle);
};

const inSameHalf = (angle1, angle2) =>{
  if(angle1 < 180 && angle2 < 180){
    return true;
  }
  else if(angle1 > 180 && angle2 > 180){
    return true;
  }
}

export const checkNextLineCatalog = (currentLine, nextLine, reverse = false) => {
  // both lines have height
  if(hasHeight(currentLine.line_angle) && hasHeight(nextLine.line_angle)){
    // both lines are in same half
    if(inSameHalf(currentLine.line_angle, nextLine.line_angle)){
      // currrent line is above next line
      if(currentLine.line_angle < 180){
        // no paddingDown
        return reverse ? 0 : 1;
      }
      else{
        // no paddingUp
        return reverse ? 1 : 0;
      }
    }  
  }
  return -1;
};

export const checkNextLineFreeform = (currentAngle, nextLineAngle, reverse = false) => {
  // both lines have height
  if(hasHeight(currentAngle) && hasHeight(nextLineAngle)){
    // both lines are in same half
    if ((currentAngle > 0 && nextLineAngle > 0) ||  (currentAngle < 0 && nextLineAngle < 0)){
      // currrent line is above next line
      if(currentAngle > 0){
        // no paddingDown
        return reverse ? 0 : 1;
      }
      else{
        // no paddingUp
        return reverse ? 1 : 0;
      }
    }  
  }
  return -1;
};